
const DeviceGrid:React.FC<{children:React.ReactNode}> = ({children}) => {

    return(
        <> 
          {/* Outer element is a plain div, not a .row: a .row nested directly in
              another .row (rather than inside a .col) doubles up the negative
              gutter margins. flex-nowrap keeps the cells on one line — the
              action button used to wrap under the serial number because the
              cells carried inline margins on top of their col widths. */}
          <div className="mt-4" style={{ paddingLeft: '1vw' }}>
                <div className='row align-items-center flex-nowrap device-row p-4'>
                   {children}
                </div>
            </div>
        </>
    )
}
export default DeviceGrid;